var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bjffff"}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"contentBox"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.name))]),_c('div',{staticClass:"vidCont"},[_c('video',{key:_vm.videoKey,attrs:{"controls":"","muted":"","src":_vm.$imgUrl + _vm.info.video},domProps:{"muted":true}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }